import { createBrowserRouter } from 'react-router-dom';
import MainLayout from '../components/Layout/MainLayout';
import HomePage from '../pages/Home';
import StudyPage from '../pages/Study';
import StudyBook from '../pages/StudyBook';
import ExamSystem from '../pages/ExamSystem';
import ExamPractice from '../pages/ExamPractice';
import Tiku from '../pages/Tiku';
import TikuCategory from '../pages/Tiku/TikuCategory';
import CategoryManage from '../pages/CategoryManage';
import UserCenter from '../pages/UserCenter';
import WrongQuestions from '../pages/WrongQuestions';
import WrongQuestionDetail from '../pages/WrongQuestionDetail';
import ErrorBoundary from '../components/ErrorBoundary';
import RouteErrorBoundary from '../components/RouteErrorBoundary';
import QuestionDetail from '../pages/QuestionDetail';
import AccountingGame from '../pages/Game/Accounting';
import PricePage from '../pages/Price';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        index: true,
        element: <HomePage />
      },
      // 学习模块
      {
        path: 'study',
        children: [
          {
            index: true,
            element: <StudyPage />
          },
          {
            path: 'book/:subCategoryCode',
            element: <StudyBook />
          }
        ]
      },
      // 知识笔记模块（新增）
      {
        path: 'study-book/:categoryCode/*',
        // 这里使用一个简单的重定向，实际功能由服务器提供静态文件
        element: null
      },
      // 题库模块
      {
        path: 'tiku',
        children: [
          {
            index: true,
            element: <Tiku />
          },
          {
            path: ':category/:subCategory',
            element: <TikuCategory />
          }
        ]
      },
      // 考试模块
      {
        path: 'exam',
        children: [
          {
            index: true,
            element: <ExamSystem />
          },
          {
            path: 'practice/:category/:examData',
            element: <ExamPractice />
          }
        ]
      },
      // 分类管理
      {
        path: 'cate',
        element: <CategoryManage />
      },
      // 用户中心
      {
        path: 'user',
        element: <UserCenter />
      },
      // 错题本
      {
        path: 'wrong-questions',
        children: [
          {
            index: true,
            element: <WrongQuestions />
          },
          {
            path: ':id',
            element: <WrongQuestionDetail />
          }
        ]
      },
      // 趣味游戏模块
      {
        path: 'game',
        children: [
          {
            path: 'accounting',
            element: <AccountingGame />
          }
        ]
      },
      {
        path: '/questions/:collection/:id',
        element: <QuestionDetail />
      },
      {
        path: '/price',
        element: <PricePage />
      }
    ]
  },
  // 单独的试题详情路由，不使用 MainLayout
  {
    path: '/questions/:collection/:id',
    element: <QuestionDetail />
  }
], {
  future: {
    v7_startTransition: true
  }
});